import { useEffect, useState } from 'react';
import { Quiz } from '../components/Quiz';
import { loadQuizData } from '../data/quran';
import { useInitialContent } from '../lib/content';
import { usePageMeta } from '../lib/seo';

export function QuizPage() {
  // Vragen komen al met de server-render mee; client-side laden is alleen de
  // terugval voor navigatie binnen de SPA. Geen lazy()/Suspense hier: dat
  // breekt renderToString, waardoor de pagina server-side leeg bleef.
  const { initialQuiz } = useInitialContent();
  const [questions, setQuestions] = useState(initialQuiz?.all ?? []);
  usePageMeta({
    title: "Juz 'Amma quiz — Test je kennis | juzamma.nl",
    description: "Oefen de volgorde, betekenis en herkenning van verzen uit alle 37 soera's van Juz 'Amma.",
    path: '/quiz',
  });
  useEffect(() => {
    if (questions.length) return;
    let active = true;
    loadQuizData().then((data) => { if (active) setQuestions(data.all); });
    return () => { active = false; };
  }, [questions.length]);
  return (
    <section className="page-section quiz-page pattern-section">
      <div className="container narrow-container">
        <div className="page-intro center-heading"><span className="eyebrow">Alle 37 soera’s</span><h1>Juz ‘Amma-quiz</h1><p>Een ronde van tien vragen over betekenis, volgorde en herkenning. De vragen zijn gemaakt uit de vastgelegde Arabische tekst en Nederlandse vertaling.</p></div>
        <Quiz questions={questions} loading={!questions.length} title="Wat herken je al?" description="Je krijgt een mix uit soera 78 tot en met 114. Er zit geen tijdslimiet op." limit={10} />
      </div>
    </section>
  );
}
